<template lang="html">


  <div class="wrapper margin-menu">

    <section class="intro column-center -home">
      <p>Tenemos el firme compromiso, con las personas y con la sociedad, de aportar nuevas herramientas y recursos capaces de mejorar su
        calidad de vida de una manera responsable.
      </p>
    </section>

    <section class="fundacion-home">
      <div class="container">
        <h2 class="big-title left -white">Fundación</h2>
        <h3 class="title-intro">La fundación</h3>
        <p>Nuestra Fundación tiene como propósito ayudar a mejorar la calidad de vida de las personas en los ámbitos de la alimentación y la salud, de la vivencia de los valores humanos y del emprendimiento innovador así como contribuir a satisfacer necesidades básicas para poblaciones desfavorecidas como como son el acceso al agua y a la educación.</p>
        <router-link :to="$t('enlaces.fundacion')" class="btn with-border">Saber más</router-link>
      </div>
      <img src="/static/img/gente-fundacion.svg" class="gente-fundacion" alt="Gente fundación">
    </section>

    <section class="selector-proyectos row-center ais">

      <div class="proyectos-list column-start">
        <h2>Proyectos</h2>
        <a :selected="selected == 'mide'" @click="selected= 'mide'"><img src="/static/img/mide-blanco.svg" alt="MIDE"></a>
        <a :selected="selected == 'agua'" @click="selected= 'agua'"><img src="/static/img/agua-para-todos-blanco.png" alt="Agua para todos"></a>
        <!-- <a :selected="selected == 'civsem'" @click="selected= 'civsem'"><img src="/static/img/civsem-blanco.svg" alt="CIVSEM"></a> -->
        <a :selected="selected == 'patio'" @click="selected= 'patio'"><img src="/static/img/logo-patio-blanco.svg" alt="PATIO"></a>
      </div>
      <div class="proyecto-selected column-center" :style="'background:url(/static/img/home-'+selected+'.jpg) center/cover no-repeat'">

        <div class="proyecto column-start">

          <template v-if="selected == 'mide'">
            <img src="/static/img/mide-blanco.svg" alt="MIDE">
            <p>La asociación MIDE pretende conectar entidades y unificar esfuerzos para mejorar la posición competitiva de la Comunidad de Madrid y contribuir al desarrollo de su ecosistema de emprendimiento</p>
            <router-link class="btn with-border" :to="$t('enlaces.mide')">Ver proyecto</router-link>
          </template>

          <template v-if="selected == 'agua'">
            <img src="/static/img/agua-para-todos-blanco.png" alt="Agua para todos">
            <p>Los problemas de escasez son un obstáculo real que sufren los habitantes de países subdesarrollados. Un solo pozo puede cambiar la vida de una aldea. Desde la Fundación queremos ayudar a mejorar la calidad de vida de estas personas a través del acceso al agua.</p>
            <router-link class="btn with-border" :to="$t('enlaces.aguaparatodos')">Ver proyecto</router-link>
          </template>
<!-- 
          <template v-if="selected == 'civsem'">
            <img src="/static/img/civsem-blanco.svg" alt="CIVSEM">
            <p>Entidad orientada al desarrollo personal y profesional, presta especial atención al emprendimiento y a la innovación.</p>
            <router-link class="btn with-border" :to="$t('enlaces.civsem')">Ver proyecto</router-link>
          </template> -->

          <template v-if="selected == 'patio'">
            <img src="/static/img/logo-patio-blanco.svg" alt="PATIO">
            <p>Un espacio neutral que nace con el objetivo de convertirse en el punto de encuentro del ecosistema innovador, conectando corporaciones, emprendedores, administración pública y todos aquellos agentes necesarios para que la innovación ocurra.</p>
            <router-link class="btn with-border" :to="$t('enlaces.patio')">Ver proyecto</router-link>
          </template>

        </div>

      </div>

    </section>

    <section class="proyecto-home-togo row-center ais">
      <div class="imagen">
        <img src="/static/img/imagen-home-togo.jpg" alt="Proyecto educativo en togo">
      </div>
      <div class="texto">
        <h2>Proyecto educativo en Togo</h2>
        <p>Contribuir al desarrollo de infraestructuras educativas gestionadas por la comunidad religiosa de las Misioneras de la Inmaculada Concepción en Togo.</p>
        <!-- <router-link :to="$t('enlaces.proyecto')+'/togo'" class="btn">Ver proyecto</router-link> -->
      </div>
    </section>


    <section class="proyectos-home" v-if="projects.length != 0">

      <img src="/static/img/logo-agua-para-todos.png" class="logo-agua-para-todos" alt="Logo agua para todos">

      
      <h3 class="title-intro no-line">¿Te animas a <strong>colaborar</strong>?</h3>
      
      <div class="contenedor-slider slider-proyectos-no-finalizados container">
        <h2 class="big-title">Colabora</h2>
        <slick
          ref="slick"
          :options="slickOptions">
          <div class="slide -proyecto" v-for="(project,key) in projects">
            <proyecto-el :key="key" :project="project"></proyecto-el>
          </div>
        </slick>
      </div>


    </section>


    <proyectos-finalizados></proyectos-finalizados>


    <!-- <noticias></noticias> -->


    <main>




    </main>

  </div>

</template>

<script lang="js">
  
  import proyecto from '@/components/parts/proyecto';

  import proyectosfinalizados from '@/components/parts/projects-finalizados';


  import noticias from '@/components/parts/noticias'


  import {mapGetters} from 'vuex'

  import Slick from 'vue-slick';
  
  export default {
    name: 'home',
    data(){
      return{
        selected : 'mide',
        slickOptions: {
                slidesToShow: 1
        },
      }
    },
    components : {
      'proyecto-el' : proyecto,
      'proyectos-finalizados' : proyectosfinalizados,
      Slick,
      'noticias' : noticias
    },
    computed:{
      ...mapGetters({
        projects : 'getProjectsNotfinish'
      })
    }
  }
    
  </script>
<style lang="scss">
  
  </style>


// WEBPACK FOOTER //
// src/components/views/home.vue